import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Hidden from '@material-ui/core/Hidden'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'

import MobileMenu from './MobileMenu'
import Menu from './Menu'
import { logOut } from 'http/auth'

interface IProps {
  pathname: string
  classes: any
  menu: any
}

/* istanbul ignore next */
const styles = ({ breakpoints, mixins }) => ({
  logo: {
    [`${breakpoints.only('xs')}`]: {
      width: '100px',
    },
    [`${breakpoints.only('sm')}`]: {
      width: '140px',
    },
    [`${breakpoints.up('md')}`]: {
      width: '160px',
    },
  },
  toolbarMargin: mixins.toolbar
})

const Navigation = ({ classes, pathname, menu }: IProps): JSX.Element => (
  <Fragment>
    <AppBar
      position="fixed"
      style={{
        backgroundColor: '#e20015',
      }}
    >
      <Box py={{ xs: 0, md: 2 }}>
        <Toolbar>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Link to="/">
                <Box ml={{ xs: 2, sm: 3, md: 5, lg: 8, xl: 10 }}>
                  <img className={classes.logo} alt="BOC Logo" src="/images/logos/boc_white.svg" />
                </Box>
              </Link>
            </Grid>
            <Grid item>
              <Box mr={{ xs: 2, sm: 3, md: 5, lg: 8, xl: 10 }}>
                <Hidden smUp>
                  <MobileMenu
                    currentPath={pathname}
                    paths={menu}
                    logOut={(): void => {
                      logOut()
                    }}
                  />
                </Hidden>
                <Hidden only="xs">
                  <Menu
                    currentPath={pathname}
                    paths={menu}
                    logOut={(): void => {
                      logOut()
                    }}
                  />
                </Hidden>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </Box>
    </AppBar>
    <div className={classes.toolbarMargin} />
  </Fragment>
)

const mapStateToProps = ({
  router: {
    location: { pathname },
  },
  auth: { menu },
}) => ({
  menu,
  pathname,
})

export default connect(mapStateToProps)(withStyles(styles)(Navigation))
